export default function homeSearch() {
  let locationsData = JSON.parse(window.search_data.locationsData);
  let programData = JSON.parse(window.search_data.programData);

  let locationFinder = {
    container:  $('#where-container'),
    selection:  $('#where-container .autocomplete-field_selection'),
    input_text:  $('#location'),
    input_data:  $('#location-data'),
    autocompleteList: function () {
      return this.container.find('.autocomplete-list');
    },
    init: function () {
      let $this = locationFinder, $body = $('body'), offset = 15;
      $this.initOnClick();

      $body.on('change keyup', '#location', function(){
        $this.processInput(this);
      });
      $this.autocompleteList().css({'width': $this.container.outerWidth() - 2 * offset, 'left': offset});
    },
    initOnClick: function(){
      let $this = locationFinder;

      $this.autocompleteList().hover(function () {
        $this.input_text.blur();
      });

      $this.autocompleteList().on('click', 'li.autocomplete-list-item', function(e){
        e.preventDefault();
        if ($(this).hasClass('autocomplete-list-item_no-result')){
          return false;
        }
        if($this.saveSelectedData(this)){
          $(this).closest('.autocomplete-list').hide({
            complete: function () {
              $this.input_text.focus();
            }
          });
        }
      });
      $this.selection.on('click', '.autocomplete-field_selection-remove', function(e){
        e.preventDefault();
        $(this).closest('.autocomplete-field_selection-item').remove();
        $this.calculateValues();
        $(this).closest('.autocomplete-list').hide();
        $this.input_text.focus();
        if ($this.input_data.val() === '') {
          $this.input_text.attr('placeholder', $this.input_text.data('placeholder'));
        }
      });
    },
    saveSelectedData: function(item){
      let $this = locationFinder,
        itm = $(item),
        type = itm.data('type'),
        value = itm.data('value'),
        title = itm.find('.autocomplete-list-item__title').html();

      const isExist = $this.selection.find('li.autocomplete-field_selection-item').filter((ind, el) => $(el).data('value') === value && $(el).data('type') === type ).length;
      if (isExist) {
        return false;
      }

      $this.selection.append(`<li class="autocomplete-field_selection-item" data-type="${type}" data-value="${value}">${title}<span class="autocomplete-field_selection-remove">x</span></li>`);

      $this.input_text.val('').attr('placeholder', '');
      $this.calculateValues();
      return true;
    },
    calculateValues: function(){
      let $this = locationFinder;
      let acc = [];

      $this.selection.find('.autocomplete-field_selection-item').map((ind, el) => {
        if (el){
          acc.push(`${$(el).data('type')}|${$(el).data('value')}`);
        }
      });

      $this.input_data.val(acc.join(','));

    },
    processInput: function(input) {
      let s = $(input).val(), html, $this = locationFinder, str = $.trim(s);
      if (str.length === 0) {
        $this.autocompleteList().html('');
        return;
      }

      let rows = $this.filterDataRows(str);
      if (rows.length === 0) {
        html = $this.getNoResultsRowHtml();
      } else {
        html = $this.renderRowItems(rows);
      }
      $this.autocompleteList().html(html).show();
    },
    renderRowItems: function(items){
      let html = '';
      items.map(function (item) {
        html += locationFinder.getRowHtml(item);
      });
      return html;
    },
    filterDataRows: function(value){
      let $this = locationFinder;
      let study_id = $('.home-study-type-icon.selected').data('id');
      const field_data = $this.input_data.val().split(',');

      return locationsData[study_id].filter(function (data) {
        const str = `${data.type}|${data.id}`;
        return data.title.toUpperCase().includes(value.toUpperCase()) && !field_data.includes(str);
      });
    },
    getRowHtml: function (data) {
      let subtitle = '';
      if (data.subtitle !== '') {
        subtitle = '<div class="autocomplete-list-item__subtitle">' + data.subtitle + '</div>';
      }

      return '<li class="autocomplete-list-item" data-type="' + data.type  + '" data-value="' + data.id  + '">' +
        '    <div class="autocomplete-list-item__icon autocomplete-list-item__icon_' + data.type + '"></div>' +
        '    <div class="autocomplete-list-item__title-row">' +
        '        <div class="autocomplete-list-item__title">' + data.title + '</div>' +
        subtitle +
        '    </div>' +
        '</li>';
    },
    getNoResultsRowHtml: function () {
      return '<li class="autocomplete-list-item autocomplete-list-item_no-result">' +
        '    <div class="autocomplete-list-item__icon"></div>' +
        '    <div class="autocomplete-list-item__title-row">' +
        '        <div class="autocomplete-list-item__title">No results</div>' +
        '    </div>' +
        '</li>';
    }
  };
  locationFinder.init();

  let programFinder = {
    container:  $('#what-container'),
    selection:  $('#what-container .autocomplete-field_selection'),
    input_text:  $('#program'),
    input_data:  $('#program-data'),
    autocompleteList: function () {
      return this.container.find('.autocomplete-list');
    },
    init: function () {
      let $this = programFinder, $body = $('body'), offset = 15;
      $this.initOnClick();

      $body.on('change keyup', '#program', function(){
        $this.processInput(this);
      });
      $this.autocompleteList().css({'width': $this.container.outerWidth() - 2 * offset, 'left': offset});
    },
    initOnClick: function(){
      let $this = programFinder;

      $this.autocompleteList().hover(function () {
        $this.input_text.blur();
      });

      $this.autocompleteList().on('click', 'li.autocomplete-list-item', function(e){
        e.preventDefault();
        if ($(this).hasClass('autocomplete-list-item_no-result')){
          return false;
        }
        if($this.saveSelectedData(this)){
          $(this).closest('.autocomplete-list').hide({
            complete: function () {
              $this.input_text.focus();
            }
          });
        }
      });

      $this.selection.on('click', '.autocomplete-field_selection-remove', function(e){
        e.preventDefault();
        $(this).closest('.autocomplete-field_selection-item').remove();
        $this.calculateValues();
        $(this).closest('.autocomplete-list').hide();
        $this.input_text.focus();
        if ($this.input_data.val() === '') {
          $this.input_text.attr('placeholder', $this.input_text.data('placeholder'));
        }
      });
    },
    saveSelectedData: function(item){
      let $this = programFinder,
        itm = $(item),
        value = itm.data('value'),
        title = itm.find('.autocomplete-list-item__title').html();

      const isExist = $this.selection.find('li.autocomplete-field_selection-item').filter((ind, el) => $(el).data('value') === value).length;
      if (isExist) {
        return false;
      }

      $this.selection.append(`<li class="autocomplete-field_selection-item" data-value="${value}">${title}<span class="autocomplete-field_selection-remove">x</span></li>`);

      $this.input_text.val('').attr('placeholder', '');
      $this.calculateValues();
      return true;
    },
    calculateValues: function(){
      let $this = programFinder;
      let acc = [];

      $this.selection.find('.autocomplete-field_selection-item').map((ind, el) => {
        if (el){
          acc.push($(el).data('value'));
        }
      });

      $this.input_data.val(acc.join(','));

    },
    processInput: function(input) {
      let s = $(input).val(), html, $this = programFinder, str = $.trim(s);
      if (str.length === 0) {
        $this.autocompleteList().html('');
        return;
      }

      let rows = $this.filterDataRows(str);
      if (rows.length === 0) {
        html = $this.getNoResultsRowHtml();
      } else {
        html = $this.renderRowItems(rows);
      }
      $this.autocompleteList().html(html).show();
    },
    renderRowItems: function(items){
      let html = '';
      items.map(function (item) {
        html += programFinder.getRowHtml(item);
      });
      return html;
    },
    filterDataRows: function(value){
      let study_id = $('.home-study-type-icon.selected').data('id'),
        data = [];
      const $this = programFinder;
      const field_data = $this.input_data.val().split(',');
      if (programData[study_id].children !== undefined) {
        programData[study_id].children.map(function (value) {
          data.push({ id: value.term_id, title: value.name});
        });
      }
      const words = [' with ',' in ','(',')', ' and '];
      words.forEach(function(element) {

       value =  value.replaceAll(element, ' ');
      });

      const values = value.split(' ');
      return data.filter(function (data) {
        return checkInput(data.title, values );
      });
    },
    getRowHtml: function (data) {
      return '<li class="autocomplete-list-item" data-value="' + data.id  + '">' +
        '    <div class="autocomplete-list-item__icon autocomplete-list-item__icon_program"></div>' +
        '    <div class="autocomplete-list-item__title-row">' +
        '        <div class="autocomplete-list-item__title">' + data.title + '</div>' +
        '    </div>' +
        '</li>';
    },
    getNoResultsRowHtml: function () {
      return '<li class="autocomplete-list-item autocomplete-list-item_no-result">' +
        '    <div class="autocomplete-list-item__icon"></div>' +
        '    <div class="autocomplete-list-item__title-row">' +
        '        <div class="autocomplete-list-item__title">No results</div>' +
        '    </div>' +
        '</li>';
    }
  };
  programFinder.init();

  function checkInput(input, words) {
    return words.some(word => input.toLowerCase().includes(word.toLowerCase()));
  }

  $('#mainSearchSubmit').on('click', function(e) {
    e.preventDefault();

    let study_type_id = $('#study_type_id').val(),
      program_data = $('#program-data').val(),
      location_data = $('#location-data').val();

    // submit if at least study type is present
    if (study_type_id) {
      let params = {
        study_type: study_type_id
      };
      if (program_data) {
        params.program = program_data;
      }
      if (location_data) {
        params.location= location_data;
      }

      let url = $.param(params);

      window.location.href = '/schools?' + url;
    }
  });

  $('.home-study-type-icon').on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('disabled')){
      return false;
    }
    let what_container = $('.what-container');
    let where_container = $('.where-container');

    $('.home-study-type-icon.selected').removeClass('selected');
    $(this).addClass('selected');

    what_container.find('input').val('');
    $('.where-container input').val('');

    let study_id = $(this).data('id');
    $('#study_type_id').val(study_id);

    if (study_id === 325) {
      what_container.hide();
      where_container.removeClass('col-md-5').addClass('col-md-10');
    } else {
      what_container.show();
      where_container.removeClass('col-md-10').addClass('col-md-5');
    }

  });

  // sticky search bar
  let filter_offset = $('.home-filter .search-form-wrapper').offset().top;
  let text_container = $('#search-filter').next();
  let text_offset = text_container.offset().top;
  // sticky();
  $(window).resize(function() {
    // sticky();
  });
  function sticky() {
    if ($(window).width() > 960) {
      $(window).bind('scroll', function (e) {

        if ($(window).scrollTop() >= filter_offset) {
          let st = e.delegateTarget.scrollY;
          let delta = (st - filter_offset) * 1; // 1.5
          let val;
          if ( delta > 100) {
            val = 100;
          } else if ( delta < 0) {
            val = 0;
          } else {
            val = delta;
          }

          let pst = (100 - val) / 100;

          // $('.search-form-wrapper').css('marginTop', 50 * pst);
          $('.search-form-heading h1').css('fontSize', 0).css('opacity', 0);

          $('#search-filter').addClass('fixed');

          text_container.css('paddingTop', text_offset);
        } else {
          $('#search-filter').removeClass('fixed');
          // $('.search-form-wrapper').css('marginTop', 50);

          text_container.css('paddingTop', 0);
          $('.search-form-heading h1').css('fontSize', 62).css('opacity', 1);
        }
      });
    } else {
      $(window).unbind('scroll');
    }
  }
}